/* eslint-disable no-unused-vars */
import { Route, Routes, Navigate, useLocation } from "react-router-dom";
import About from "./components/About/index";
import HomeOne from "./components/HomeOne/index";
import Login from "./components/Login";
import Register from "./components/Register";
import AccountDetail from "./components/AccountDetail";

import { PrivateRouterOutlet } from "./routes/private";
import { PublicRouterOutlet } from "./routes/public";
import ForgotPassword from "./components/ForgotPassword";
import ResetPassword from "./components/ResetPassword";
import OTPscreen from "./components/OTPscreen";
import PrivacyPolicy from "./components/PrivacyPolicy";
import AdInformation from "./components/AdInformation";
import Services from "./components/Services";
import Contact from "./components/Contact/index";
import CartModule from "./components/CartModule";
import WalletModule from "./components/WalletModule";
import ProductDetail from "./components/ProductDetail";
import WinnerList from "./components/WinnerList";
import DrawsPage from "./components/DrawsPage";
import ProductsPage from "./components/ProductsPage";
// import Games from "./components/Games"; // Commented out as per requirement
// import NumberGame from "./components/NumberGame"; // Commented out as per requirement

export default function Routers() {
  return (
    <>
      <Routes>
        <Route exact path="/" element={<HomeOne />} />
        <Route exact path="/login" element={<PublicRouterOutlet />}>
          <Route path="" element={<Login />} />
        </Route>
        <Route exact path="/forgot-password" element={<PublicRouterOutlet />}>
          <Route path="" element={<ForgotPassword />} />
        </Route>
        <Route exact path="/register" element={<PublicRouterOutlet />}>
          <Route path="" element={<Register />} />
        </Route>
        <Route exact path="/otp-verification" element={<PublicRouterOutlet />}>
          <Route path="" element={<OTPscreen />} />
        </Route>

        <Route exact path="/reset-password" element={<ResetPassword />} />

        <Route exact path="/about" element={<About />} />
        {/* <Route exact path="/games" element={<Games />} /> */}
        {/* <Route exact path="/games" element={<NumberGame />} /> */}

        <Route exact path="/privacy-policy" element={<PrivacyPolicy />} />
        <Route exact path="/user-agreement" element={<AdInformation />} />
        <Route exact path="/services" element={<Services />} />
        <Route exact path="/contact" element={<Contact />} />
        <Route exact path="/product/:id" element={<ProductDetail />} />
        <Route exact path="/winner-list" element={<WinnerList />} />
        <Route exact path="/draws" element={<DrawsPage />} />
        <Route exact path="/products" element={<ProductsPage />} />
        <Route exact path="/cart" element={<PrivateRouterOutlet />}>
          <Route path="" element={<CartModule />} />
        </Route>
        <Route exact path="/wallet" element={<PrivateRouterOutlet />}>
          <Route path="" element={<WalletModule />} />
        </Route>
        <Route exact path="/account-detail" element={<PrivateRouterOutlet />}>
          <Route path="" element={<AccountDetail />} />
        </Route>
        <Route exact path="*" element={<Navigate to="/" replace />} />
      </Routes>
    </>
  );
}
